// Danish VAT (moms) is 25%. Headline prices are incl. moms.
export const MOMS_RATE = 0.25;

export const exclMoms = (inclMoms) => inclMoms / (1 + MOMS_RATE);

// Format a number as Danish kroner. decimals=0 -> "389", decimals=2 -> "311,20"
export const formatDKK = (value, decimals = 0) =>
  value.toLocaleString("da-DK", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

// Returns { incl, excl, unit } display strings for a headline price.
export const priceStrings = (inclMoms, unit = "") => ({
  incl: `${formatDKK(inclMoms)} kr${unit}`,
  excl: `${formatDKK(exclMoms(inclMoms), 2)} kr${unit}`,
});
